import TableComponent, { IColumnProps } from '../TableComponent';
import React, { useState } from 'react';
import ModalComponent from '../ModalComponent';
import {
  useGetAllLogsByDeviceAsync,
  useGetAllLogsByDeviceCountAsync,
} from '../../services/Events/LogService/hooks/useQuery';
import { IPaginationParams } from '../../services/types';

interface LogsModalComponentProps {
  deviceId: number;
  isVisible: boolean;
  setIsVisible: (val: boolean) => void;
}

const LogsModalComponent = ({
  deviceId,
  setIsVisible,
  isVisible,
}: LogsModalComponentProps) => {
  const [logPaginationParams, setLogPaginationParams] =
    useState<IPaginationParams>({ pageNumber: 1, pageSize: 10 });
  const { data: logs } = useGetAllLogsByDeviceAsync(
    deviceId,
    logPaginationParams,
  );
  const { data: count } = useGetAllLogsByDeviceCountAsync(
    deviceId,
    logPaginationParams,
  );

  const columns: IColumnProps[] = [
    {
      id: 'description',
      label: 'Descrição',
      width: '80%',
    },
    {
      id: 'createdAt',
      label: 'Data/Hora',
      width: 205,
      render: (val) => <>{new Date(val).toLocaleString('pt-BR')}</>,
    },
  ];

  return (
    <ModalComponent
      onClose={() => setIsVisible(false)}
      isOpen={isVisible}
      title={'Logs do dispositivo'}
    >
      <TableComponent
        height={'50%'}
        columns={columns}
        onChangePageOrRowsPerPage={setLogPaginationParams}
        rows={logs ?? []}
        totalCount={count ?? 0}
      />
    </ModalComponent>
  );
};

export default LogsModalComponent;
